__turbopack_context__.v({
  "askCaret": "coach-module-scss-module__pqzNUG__askCaret",
  "askCursor": "coach-module-scss-module__pqzNUG__askCursor",
  "askDisclaimer": "coach-module-scss-module__pqzNUG__askDisclaimer",
  "askFooter": "coach-module-scss-module__pqzNUG__askFooter",
  "askInput": "coach-module-scss-module__pqzNUG__askInput",
  "askInputGroup": "coach-module-scss-module__pqzNUG__askInputGroup",
  "askOption": "coach-module-scss-module__pqzNUG__askOption",
  "askOptionFill": "coach-module-scss-module__pqzNUG__askOptionFill",
  "askOptions": "coach-module-scss-module__pqzNUG__askOptions",
  "askPlaceholder": "coach-module-scss-module__pqzNUG__askPlaceholder",
  "askReplies": "coach-module-scss-module__pqzNUG__askReplies",
  "askSend": "coach-module-scss-module__pqzNUG__askSend",
  "askWindow": "coach-module-scss-module__pqzNUG__askWindow",
  "chatGeist": "coach-module-scss-module__pqzNUG__chatGeist",
  "stage": "coach-module-scss-module__pqzNUG__stage",
  "thread": "coach-module-scss-module__pqzNUG__thread",
  "typingDot": "coach-module-scss-module__pqzNUG__typingDot",
});
